/**
 * @fileoverview Location component for managing company address information.
 * This component handles primary and secondary business addresses including
 * street, city, state, postal code, and neighborhood fields with visibility
 * toggle controls for public profile display.
 */

import React from "react";
import { useTranslation } from "react-i18next";
import LocationSectionView from "./LocationSectionView";
import { useLocationSection } from "./useLocationSection";

/**
 * Location component for displaying and editing company address information.
 * Manages primary and secondary addresses with Mexican geographic reference data
 * (states, municipalities, neighborhoods, postal codes) and visibility toggles.
 *
 * @param {Object} props - Component props
 * @param {Object} props.company - Company data object containing address fields
 * @param {Function} props.onFieldChange - Callback function triggered when a field value changes
 * @param {Function} props.onValidationChange - Callback function triggered when validation state changes
 * @param {number} [props.selectedProfile=0] - Currently selected company profile index for multi-profile support
 * @returns {JSX.Element} The rendered Location form section
 */
const Location = ({
  company,
  onFieldChange,
  onValidationChange,
  selectedProfile = 0,
}) => {
  const { t } = useTranslation();
  const model = useLocationSection({
    company,
    onFieldChange,
    onValidationChange,
    selectedProfile,
  });

  return <LocationSectionView model={model} t={t} />;
};

export default Location;
